import useGetPermissions from 'app/hooks/useGetPermissions'

import {
    AccessRight,
    AccessRightsConfig,
} from 'app/types/accessRights.types'
import getCategoryTypePermission from './getCategoryTypePermission'

import accessRoles from './accessRoles'

const useGetAllowedCategoryType = (accessRights: AccessRightsConfig, type: keyof AccessRight) => {
    const permissionsList = useGetPermissions(accessRoles)

    return getCategoryTypePermission(accessRights, permissionsList, type)
}

export default useGetAllowedCategoryType
